/**
 * Cancel Enrollment Dialog (iter271 — extracted from Enrollments.js).
 * Permanent cancellation with mandatory notes + effective date.
 */
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter,
} from '../../../components/ui/dialog';
import { Button } from '../../../components/ui/button';
import { Input } from '../../../components/ui/input';
import { Label } from '../../../components/ui/label';
import { Textarea } from '../../../components/ui/textarea';
import { Ban, Calendar } from 'lucide-react';

export default function CancelEnrollmentDialog({
  open,
  onOpenChange,
  selectedEnrollment,
  actionData,
  setActionData,
  onConfirm,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="font-heading text-xl flex items-center gap-2">
            <Ban className="h-5 w-5 text-red-500" />
            Cancel Enrollment
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4 mt-4">
          <div className="p-3 bg-slate-50 rounded-lg">
            <p className="font-medium text-slate-900">{selectedEnrollment?.player_name}</p>
            <p className="text-sm text-slate-500">Program: {selectedEnrollment?.program_name}</p>
          </div>

          <div className="p-3 bg-red-50 rounded-lg border border-red-200">
            <p className="text-sm text-red-700">
              <strong>Warning:</strong> Canceling an enrollment is permanent. The player will be removed from all associated classes.
            </p>
          </div>

          <div className="space-y-2">
            <Label className="flex items-center gap-2">
              <Calendar className="h-4 w-4 text-red-500" />
              Cancellation Effective Date *
            </Label>
            <Input
              type="date"
              value={actionData.cancel_date}
              onChange={(e) => setActionData({ ...actionData, cancel_date: e.target.value })}
              data-testid="cancel-date-input"
            />
            <p className="text-xs text-slate-500">When should this enrollment be canceled?</p>
          </div>

          <div className="space-y-2">
            <Label>
              Notes <span className="text-red-500">*</span>
            </Label>
            <Textarea
              value={actionData.notes}
              onChange={(e) => setActionData({ ...actionData, notes: e.target.value })}
              placeholder="Required — record why this enrollment is being cancelled."
              required
              data-testid="cancel-notes-input"
            />
          </div>

          <DialogFooter className="flex justify-end gap-3 pt-4">
            <Button variant="outline" onClick={() => onOpenChange(false)}>Keep Active</Button>
            <Button
              className="bg-red-500 hover:bg-red-600"
              onClick={onConfirm}
              disabled={!(actionData.notes || '').trim() || !actionData.cancel_date}
              data-testid="confirm-cancel-btn"
            >
              <Ban className="h-4 w-4 mr-1" />
              Cancel Enrollment
            </Button>
          </DialogFooter>
        </div>
      </DialogContent>
    </Dialog>
  );
}
